import React, { useState } from 'react';
import styled from 'styled-components';

import { getLocationsByAddress } from 'services/LocationService/placePredictions';
import { GeoCodeLocation } from 'services/LocationService/types';
import Logger from 'services/Logger';

import { LocationAutoComplete } from './autocomplete';

interface GooglePlacesInput {
  clearMyLocation: Function;
  flex?: string;
  handleOnPress: (val: GeoCodeLocation) => void;
  hideIcon?: boolean;
  noOptionsText?: string;
  placeholder?: string;
  useMyLocation?: boolean;
  width?: string;
}

const Container = styled.div<{ width?: string; flex?: string }>`
  width: ${props => props.width || '100%'};
  ${props => (props.flex ? `flex: ${props.flex};` : '')}
`;

export function GooglePlacesInput({
  clearMyLocation,
  flex,
  handleOnPress,
  hideIcon,
  noOptionsText,
  placeholder,
  useMyLocation,
  width
}: GooglePlacesInput) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [options, setOptions] = useState([] as GeoCodeLocation[]);

  const handleInputChange = (text: string) => {
    setIsLoading(true);

    if (!text || text.length <= 2) {
      setIsLoading(false);
      setOptions([]);
      clearMyLocation();
      return;
    }

    getLocationsByAddress(text, 2, true)
      .then(results => {
        const newOptions = results.map(result => ({
          ...result,
          description: (result as GeoCodeLocation).formatted_address
        }));

        setOptions(newOptions);
      })
      .catch(err => Logger.error(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <Container width={width} flex={flex}>
      <LocationAutoComplete
        clearMyLocation={clearMyLocation}
        handleInputChange={handleInputChange}
        hideIcon={hideIcon}
        isLoading={isLoading}
        noOptionsText={noOptionsText}
        handleOnPress={handleOnPress}
        options={options}
        placeholder={placeholder}
        testId="location-input"
        useMyLocation={useMyLocation}
      />
    </Container>
  );
}
